(function () {
  'use strict';

  angular.module('socket.pusher').service('SocketPusher', SocketPusher);

  SocketPusher.$inject = ['$rootScope', '$pusher'];

  function SocketPusher($rootScope, $pusher) {
    var vm = this;
    vm.subscribe = subscribe;
    vm.unsubscribe = unsubscribe;
    vm.bind = bind;
    vm.channel = null;

    //debug mode on/off
    Pusher.logToConsole = false;

    vm.client = new Pusher('4deb652fe59cea0230e9', {
      cluster: 'eu',
      encrypted: true,
      authEndpoint: '/api/user/pusher/auth',
      auth: {
        params: {
          token: $rootScope.token,
        },
      },
    });

    vm.pusher = $pusher(vm.client);

    function subscribe(channelName) {
      vm.channel = vm.pusher.subscribe(channelName);
      startListen();
    }

    function unsubscribe(channelName) {
      vm.pusher.unsubscribe(channelName);
      vm.channel = null;
    }

    function bind(event, handler) {
      vm.channel.bind(event, function (data) {
        handler(data);
      });
    }

    function me() {
      return vm.channel.members.me;
    }

    function startListen() {
      vm.channel.bind('pusher:subscription_succeeded', function (members) {
        $rootScope.$broadcast('socket.pusher.subscription_succeeded', members);
      });

      vm.channel.bind('pusher:subscription_error', function (status) {
        $rootScope.$broadcast('socket.pusher.subscription_error', status);
      });

      vm.channel.bind('pusher:member_added', function (member) {
        $rootScope.$broadcast('socket.pusher.member_added', member);
      });

      vm.channel.bind('pusher:member_removed', function (member) {
        $rootScope.$broadcast('socket.pusher.member_removed', member);
      });
    }

    return {
      subscribe: subscribe,
      unsubscribe: unsubscribe,
      bind: bind,
      me: me,
    };
  }
})();
